<div class="contentHeight form noPrint">
  <h1 class="titleContretypage">{{'contretypage.titleRequestForm'|translate}}</h1>
  <mat-horizontal-stepper [linear]="true" #stepper class="backgroundWhiteRound">

    <!-- STEP 1 -->

    <mat-step>

      <!--<form class="example-form">
        <mat-form-field class="example-full-width">
          <mat-label>Pick one</mat-label>
          <input type="text" aria-label="Number" matInput [formControl]="myControl" [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of options" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>-->

      <ng-template matStepLabel>{{'contretypage.stepInfo'|translate}}</ng-template>
      <div class="row" [ngClass]="Utils.isCTC(role) ? 'ctcConnect': ''">
        <div class="col-lg-6 col-md-12 mt-3 paddingRightContretypage">
          <div class="col-lg-12">
            <h3 *ngIf="Utils.isUserIxell(role)" class="substitle" [translate]="'contretypage.vous'"> </h3>
            <h3 *ngIf="Utils.isCTC(role)" class="substitle">
              {{'contretypage.vclient'|translate}}
              <i aria-hidden="true" class="fas fa-info-circle" matTooltip="{{'contretypage.tooltipInfoClient'|translate}}"></i>
            </h3>
            <hr>
          </div>
          <!-- companyForm - isCTC -->
          <form *ngIf="Utils.isCTC(role)" class="col-lg-12 col-lg-offset-2 col-md-12" [formGroup]="companyForm">
            <fieldset>
              <legend></legend>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                <input matInput type="text" formControlName="postalCode" autocomplete="off" required>
              </mat-form-field>
              <button *ngIf="Utils.isCTC(role)" class="btn btn-secondary m-2" [translate]="'monitoring.search'" (click)="getCompanyByCP()"></button>
              <mat-form-field class="col-lg-6">

                <!--(ngModelChange)="SelectCompany()"
                <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                <input matInput type="text" formControlName="socialReason" id="socialReason" list="companiesCM" autocomplete="off" />
                <datalist id="companiesCM">
                  <select id="company_autocomplete_select">
                    <option *ngFor="let companyCM of companiesCM" value="{{companyCM.company_SocialReason}}" data-id="{{companyCM.userCompanyID}}-{{companyCM.colorUserID}}" (click)="SelectCompany(companyCM)">{{companyCM.company_Country}} - {{companyCM.company_PostalCode}}</option>
                  </select>
                </datalist>-->
                
                <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                <input matInput type="text" aria-label="Number" formControlName="socialReason" [matAutocomplete]="auto" autocomplete="off">
                <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete-socialReason">
                  <mat-option *ngFor="let companyCM of companiesCM" value="{{companyCM.company_SocialReason}}" (click)="SelectCompany(companyCM)">
                    <div class="socialReason-mat-option">
                      <strong>{{companyCM.company_SocialReason}}</strong>
                    </div>
                    <div class="socialReason-mat-option">
                      {{companyCM.company_Country}} - {{companyCM.company_PostalCode}}
                    </div>
                  </mat-option>
                </mat-autocomplete>

              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                <input matInput type="text" formControlName="address" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                <input matInput type="text" formControlName="city"required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                <mat-select formControlName="country" required>
                  <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                </mat-select>
              </mat-form-field>
            </fieldset>
          </form>
          <!-- userForm -->
          <form class="col-lg-12 col-lg-offset-2 col-md-12" [formGroup]="userForm">
            <fieldset>
              <legend></legend>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.nom'|translate}}</mat-label>
                <input matInput type="text" formControlName="name" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
                <input matInput type="text" formControlName="firstname" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.mail'|translate}}</mat-label>
                <input matInput type="text" formControlName="mail" required>
                <mat-error [translate]="'scaleform.mailerror'"></mat-error>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.mobile'|translate}}</mat-label>
                <input matInput type="text" formControlName="mobile" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.telephone'|translate}}</mat-label>
                <input matInput type="text" formControlName="phone">
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.langues'|translate}}</mat-label>
                <mat-select formControlName="language" required>
                  <mat-option *ngFor="let language of languages" value="{{language.name}}"> {{language.txt|translate}} </mat-option>
                </mat-select>
              </mat-form-field>
            </fieldset>
          </form>
          <!-- companyForm - isUserIxell -->
          <form *ngIf="Utils.isUserIxell(role)" class="col-lg-12 col-lg-offset-2 col-md-12" [formGroup]="companyForm">
            <fieldset>
              <legend></legend>
              <mat-form-field class="col-lg-12">
                <mat-label>{{'scaleform.raisonsociale'|translate}}</mat-label>
                <input matInput type="text" formControlName="socialReason" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.adresse'|translate}}</mat-label>
                <input matInput type="text" formControlName="address" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.codepostal'|translate}}</mat-label>
                <input matInput type="text" formControlName="postalCode" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.ville'|translate}}</mat-label>
                <input matInput type="text" formControlName="city" required>
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'scaleform.pays'|translate}}</mat-label>
                <mat-select formControlName="country" required>
                  <mat-option *ngFor="let country of countries" value="{{country.name}}"> {{country.txt|translate}} </mat-option>
                </mat-select>
              </mat-form-field>
            </fieldset>
          </form>
        </div>

        <div class="col-lg-6 col-md-12 mt-3 paddingLeftContretypage">
          <div class="col-lg-12">
            <h3 *ngIf="Utils.isCTC(role)" class="substitle" [translate]="'contretypage.vous'"> </h3>
            <h3 *ngIf="Utils.isUserIxell(role)" class="substitle" [translate]="'contretypage.vctc'"> </h3>
            <hr>
          </div>
          <form class="col-lg-12 col-lg-offset-2 col-md-12" [formGroup]="ctcForm">

            <mat-form-field class="col-lg-6">
              <mat-label>{{'scaleform.mail'|translate}}</mat-label>
              <input matInput type="text" formControlName="mail">
              <!--<mat-error [translate]="'scaleform.mailerror'"></mat-error>-->
            </mat-form-field>
            <mat-form-field *ngIf="Utils.isUserIxell(role)" class="col-lg-6">
              <mat-label>{{'scaleform.mobile'|translate}}</mat-label>
              <input matInput type="text" formControlName="phone" autocomplete="off" /><!--list="ctcList" (ngModelChange)="selectCtcs()" autocomplete="off" required>-->
              <!--(change)="getCTCByPhone()"-->

              <!--<datalist id="ctcList">
                <select>
                  <option *ngFor="let ctc of ctcList" value="{{ctc}}"></option>
                </select>
              </datalist>-->
            </mat-form-field>
            <!--<button *ngIf="Utils.isUserIxell(role)" class="btn btn-secondary m-2" [translate]="'monitoring.search'" (click)="getCTCByPhone()"></button>-->
            <mat-form-field class="col-lg-6">
              <mat-label>{{'scaleform.nom'|translate}}</mat-label>
              <input matInput type="text" formControlName="name">
              <!-- <mat-error>Saisissez le nom de l'utilisateur </mat-error> -->
            </mat-form-field>
            <mat-form-field class="col-lg-6">
              <mat-label>{{'scaleform.prenom'|translate}}</mat-label>
              <input matInput type="text" formControlName="firstname">
              <!-- <mat-error>Saisissez le prénom de l'utilisateur </mat-error> -->
            </mat-form-field>
            <mat-form-field *ngIf="Utils.isCTC(role)" class="col-lg-6">
              <mat-label>{{'scaleform.mobile'|translate}}</mat-label>
              <input matInput type="text" formControlName="phone">
            </mat-form-field>
          </form>
        </div>
      </div>
      <div class="step1">
        <button *ngIf="Utils.isUserIxell(role)" class="btn btn-secondary m-2" [translate]="'scaleform.suivant'" (click)="checkCTC(stepper)"></button>
        <button *ngIf="Utils.isCTC(role)" class="btn btn-secondary m-2" [translate]="'scaleform.suivant'" (click)="checkUser(stepper)"></button>
      </div>
    </mat-step>

    <!-- STEP 2 -->

    <mat-step>
      <ng-template matStepLabel>{{'contretypage.stepColorMatching'|translate}}</ng-template>
      <div class="row">
        <form [formGroup]="colorMatchingForm" class="col-12 row">
          <div class="col-12 col-md-6 flexColumn mt-3 paddingRightContretypage">
            <div>
              <h3 class="substitle" [translate]="'contretypage.titleVehicule'"></h3>
              <hr>
              <mat-form-field class="col-lg-4">
                <mat-label>{{'common.manufacturer'|translate}}</mat-label>
                <input matInput type="text" formControlName="brandVehicle" (ngModelChange)="selectManufacturers()" list="manufacturerList" autocomplete="off" />
                <datalist id="manufacturerList">
                  <select>
                    <option *ngFor="let m of manufacturerList" value="{{m}}"></option>
                  </select>
                </datalist>
              </mat-form-field>
              <mat-form-field class="col-lg-4">
                <mat-label>{{'search.model'|translate}}</mat-label>
                <input matInput type="text" id="colorMatchingForm-modelVehicle" formControlName="modelVehicle" autocomplete="off" />
              </mat-form-field>
              <mat-form-field class="col-lg-4">
                <mat-label>{{'search.year'|translate}}</mat-label>
                <input matInput type="number" id="colorMatchingForm-yearVehicle" formControlName="yearVehicle" autocomplete="off" />
              </mat-form-field>
            </div>
            <div>
              <h3 class="substitle" [translate]="'contretypage.titleEltContretype'"> </h3>
              <hr>

              <div class="col-lg-12">
                <fieldset class="noMargin row fieldset">
                  <legend></legend>
                  <mat-radio-group class="row ml-2" formControlName="elementAContretyper" required>

                    <mat-radio-button *ngFor="let checkbox of allCheckboxElementContretyper; let i = index" [checked]="i === 0" class="m-2" (change)="updateElementAContretyper($event, checkbox)" [value]="checkbox.id"> <!--[checked]="checkbox.checked">-->
                      <span class="translate-elementAContretyper" [translate]="checkbox.text">error translate</span>
                    </mat-radio-button>
                    <!--(change)="updateElementAContretyper($event, checkbox)"-->

                    <!--<mat-radio-button class="m-2" value="1"> <span [translate]="'contretypage.elemDecoupe'">Elément de découpe</span></mat-radio-button>
                    <mat-radio-button class="m-2" value="2"> <span [translate]="'contretypage.trappeEssence'">Trappe à essence</span></mat-radio-button>
                    <mat-radio-button class="m-2" value="3"> <span [translate]="'contretypage.elemCarrosserie'">Elément de carrosserie</span></mat-radio-button>
                    <mat-radio-button class="m-2" value="4"> <span [translate]="'contretypage.Autres'">Autres</span></mat-radio-button>-->
                  </mat-radio-group>
                </fieldset>
              </div>

              <mat-form-field class="col-lg-12" id="mat-form-field-designationOriginElement">
                <mat-label>{{'common.designation'|translate}}*</mat-label>
                <input matInput type="text" id="colorMatchingForm-designationOriginElement" formControlName="designationOriginElement" autocomplete="off">
              </mat-form-field>

            </div>
            <div>
              <h3 class="substitle" [translate]="'contretypage.titleEltPeindre'"></h3>
              <hr>
              <div class="col-lg-12">
                <fieldset class="noMargin row fieldset">
                  <legend></legend>
                  <legend class="legend">{{'contretypage.teinte'|translate}}</legend>
                  <mat-radio-group class="row ml-2" formControlName="colorOriginElement" required>
                    <mat-radio-button class="m-2" value="1" [checked]="true"> <span [translate]="'contretypage.teinteCarrosserie'">Teinte Carrosserie</span></mat-radio-button>
                    <mat-radio-button class="m-2" value="2"> <span [translate]="'contretypage.teinteAccess'">Teinte Accessoire</span></mat-radio-button>
                    <mat-radio-button class="m-2" value="3"> <span [translate]="'contretypage.Autres'">Autres</span></mat-radio-button>
                  </mat-radio-group>
                </fieldset>
              </div>
              <mat-form-field class="col-lg-12">
                <mat-label>{{'common.designation'|translate}}</mat-label>
                <input matInput type="text" formControlName="designationFinalElement" autocomplete="off">
              </mat-form-field>

            </div>
          </div>
          <div class="col-12 col-md-6 mt-3 paddingLeftContretypage">
            <div>
              <h3 class="substitle" [translate]="'contretypage.Autres'"></h3>
              <hr>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'contretypage.codepeinture'|translate}}</mat-label>
                <input matInput type="text" formControlName="codePainting" autocomplete="off">
              </mat-form-field>
              <mat-form-field class="col-lg-6">
                <mat-label>{{'contretypage.designation'|translate}}</mat-label>
                <input matInput type="text" formControlName="designationPainting" autocomplete="off">
              </mat-form-field>
              <div class="col-lg-12">
                <fieldset class="noMargin row fieldset">
                  <legend></legend>
                  <legend class="legend">{{ 'common.technology' | translate}}* : </legend>

                  <div class="row ml-2">
                    <div *ngFor="let checkbox of allCheckboxQuality">
                      <!-- ; let i = index" formGroupName="multiplePaintQuality">  [formControlName]="i" -->
                      <mat-checkbox class="m-2" (change)="updatePaintQuality($event, checkbox)" [value]="checkbox.id" [checked]="checkbox.value"> {{ checkbox.text }}</mat-checkbox>
                    </div>
                  </div>

                </fieldset>
                <div id="div-matErrorCheckbox">
                  <mat-error class="matErrorCheckbox" [translate]="'contretypage.techObligatoire'"></mat-error>
                </div>
              </div>
              <mat-form-field class="col-lg-12">
                <textarea matInput formControlName="comment" placeholder="{{'contretypage.comment'|translate}}" class="comment" autocomplete="off"></textarea>
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="col-12 text-center text-warning" [translate]="'scaleform.errorform'"> </div>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <button class="btn btn-secondary" [translate]="'scaleform.precedent'" matStepperPrevious></button>
        <button class="btn btn-secondary text-center" (click)="sendAllData()" [translate]="'scaleform.envoyer'"></button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>

  <!-- Modal de demande d'impression du n° de demande de contretypage -->
  <div id="finalModal" class="modal">
    <div class="modal-content">
      <span class="text-right mr-2 pointer close" (click)="closeModal();">  <i aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i> </span>
      <div class="container">
        <i aria-hidden="true" class="fal fa-badge-check iconBackground"></i>
        <div class="upperText">
          <h2 class="text-center">{{'contretypage.titleImp'|translate}}{{idContretypage}}</h2>
          <div class="row">
            <div class="col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
              <p class="text-center" [translate]="'contretypage.contentImp'"> </p>
            </div>
          </div>
        </div>
        <div class="center centerBtnFinalModal">
          <button class="btn btn-secondary ignoreFinalModal" type="button" name="Cancel" value="Cancel" (click)="closeModal()">
            <span [translate]="'contretypage.Ignorer'"></span>
          </button>
          <button class="btn btn-secondary printFinalModal" type="button" name="Valider" value="Valider" (click)="print()">
            <span [translate]="'contretypage.Imprimer'"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="toPrint">
  <div class="headerPrint col-12">
    <img class="enteteImp" src="assets/Impression/entetePrint.png" alt=""/>
    <h2 class="enteteContent">{{ 'contretypage.stepColorMatching' | translate}}</h2>
    <img class="imgImp" src="assets/Impression/peintre.png" alt=""/>
  </div>
  <div class="contentPrint col-12">
    <div class="accroche">
      {{'contretypage.accrocheImp'|translate}}
    </div>
    <div class="infoContretypage col-6">
      <p>{{'contretypage.demande'|translate}} : {{idContretypage}}</p>
      <p>{{'common.manufacturer'|translate}} : {{ colorMatchingRequest.brandVehicle }}</p>
      <p>{{ 'details.code' | translate}} : {{ colorMatchingRequest.codePainting }}</p>
      <p>{{'contretypage.designation'|translate}} : {{ colorMatchingRequest.designationPainting }}</p>
      <p>{{ 'monitoring.date' | translate}} :</p>
      <p>
        {{ 'common.technology' | translate}} :
        <!--<span *ngIf="colorMatchingRequest.paintQuality != undefined; then showTechnoImp else notShow"></span>-->
        <ng-template #showTechnoImp> {{ Technologie[colorMatchingRequest.paintQuality]  }}</ng-template>
      </p>
    </div>
  </div>
  <div class="headerPrint col-12">
    <img class="footerImp" src="assets/bandeau.png" alt=""/>
</div>
</div>
